import { FORCE_ACTIONS } from '../actions';
import { ForceState } from '../state';

export const loadAllForcesReducer = (state: ForceState, { forces }: ReturnType<typeof FORCE_ACTIONS.LOAD_ALL_FORCES>) => {
    return {
        ...state,
        forces
    };
};
